import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class DriverPostAddService {
  constructor(private http: HttpClient) {}
  // ton apis
  getDriverPosts(data) {
    return this.http.post(environment.apiUrl + "vacant/vehicles/search", data);
  }
  delete(id){
     return this.http.delete(environment.apiUrl + `vacant/vehicles/delete/${id}`);
  }
}
